<template>
  <div class="categories needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="categories.title" text="categories.info" ></Info>
    <div class="title">
      <h3>{{$t('categories.title')}}</h3>
      <h2>{{$t('categories.description')}}</h2>
    </div>
    <div class="main-content" :class="{'full': fullscreen}">
      <chartist id="categories" class="segment-chart" ref="chart" :data="chartData" :options="chartOptions" type="Pie" :event-handlers="eventHandlers"  v-if="chartData.series.length > 0"></chartist>
      <div class="legend">
        <ul class="point-legends" v-if="result">
          <li v-for="(cat, index) in getItems">
            <div :class="getClassPoint(index)"></div>
            <div class="text-legend">
              <div>{{cat.key}}</div>
              <div>{{cat.quantities.value | getKNumber | splitNumber}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Categories',
    components: {
      Info
    },
    props: {
      result: Object, 
      nbOfColumns: Number
    },
    watch: {
      result(new_value, old_value) {
        this.refresh()
      }, 
      nbOfColumns() {
        this.refresh()
      }
    },
    data() {
      return {
        fullscreen: false,
        chartOptions: {
          donut: true,
          donutWidth: 10,
          donutSolid: true,
          startAngle: 0,
          showLabel: false,
        },
        totalClient: 0,
        myHeight: 0,
        myWidth: 0, 
        eventHandlers: []
      }
    },
    computed: {
      getItems() {
        if (this.result && this.result.aggregations && this.result.aggregations['to-bills'] && this.result.aggregations['to-bills'].bills && this.result.aggregations['to-bills'].bills.details && this.result.aggregations['to-bills'].bills.details['filtered-results'] && this.result.aggregations['to-bills'].bills.details['filtered-results'].categories) {
          return this.result.aggregations['to-bills'].bills.details['filtered-results'].categories.buckets
        }
        return []
      },
      total() {
        const items = this.getItems
        return items.reduce((a, b) => a + (b.quantities ? b.quantities.value : 0), 0)
      }, 
      chartData() {
        const items = this.getItems
        let categories = items.map((a) => a.quantities ? a.quantities.value : 0)
        return {series: categories}
      }
    },
    mounted() {
      this.totalClient = this.chartData.series[0] + this.chartData.series[1]
    },
    methods: {
      onFullScreen() {
        if(this.myHeight == 0) {
          this.myHeight = document.getElementById('categories').clientHeight - 4
          this.myWidth = document.getElementById('categories').clientWidth
        }
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          this.chartOptions.width = "40vw"
          this.chartOptions.height = "40vh"
        } else {
          this.chartOptions.width = `${this.myWidth}px`
          this.chartOptions.height = `${this.myHeight}px`
        }
        this.$refs.chart.redraw()
      }, 
      getClassPoint(index) {
        let i = index + 1
        return `point point${i}`
      }, 
      refresh() {
        if(this.$refs.chart){
          console.log("refresh cat chart")
          this.$refs.chart.redraw()
        }
      }
    },
    created() {
      let that = this
      this.eventHandlers = [{event:'created', fn() {that.$emit("refreshedChart")}}]
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/categories.sass"
</style>
